/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  if ($('.js-large-refinements:visible').length !== 0) {
    var $checkedInputs = $(".js-sort-filter__refinements input:checked");

    if ($checkedInputs.length > 0) {
      $checkedInputs.closest('.js-tab').find('.js-tab__label').addClass("js-tab__label--active");
      $checkedInputs.closest('.js-tab').find('.js-tab__content').addClass("js-tab__content--active");
    } else {
      $(".js-sort-filter__refinements .js-tab:first-child .js-tab__label").addClass("js-tab__label--active");
      $(".js-sort-filter__refinements .js-tab:first-child .js-tab__content").addClass("js-tab__content--active");
    }
  }

  $(".js-sort-filter__toggle").on('click', function() {
    $(this).toggleClass("js-sort-filter__toggle--active");
    return $(this).parents('.js-sort-filter').find('.js-sort-filter__refinements').toggleClass('js-dn');
  });

  $('.js-sort-filter__clear-checkboxes').on('click', function() {
    $($(this).data('target')).find(':checked').prop('checked', false);
    update_clear_checkboxes();
    $(this).closest('form').submit();
    return false;
  });

  $('.js-sort-filter__clear-all-checkboxes').on('click', function() {
    $(this).closest('.js-sort-filter').find('.checkbox :checked').prop('checked', false);
    update_clear_checkboxes();
    return $(this).closest('form').submit();
  });

  $('select#sort').on('change', function() {
    return $(this).closest('form').submit();
  });

  // $('input#refine').on 'click', ->
  //   $('html').trigger('consumer:filters:update')

  var update_clear_checkboxes = function update_clear_checkboxes() {
    var filtering = Boolean($('.js-sort-filter').find('.checkbox :checked')[0]);
    return $('.js-sort-filter__clear-all-checkboxes').toggleClass('js-dn', !filtering);
  };

  $('.js-sort-filter .checkbox').on('change', update_clear_checkboxes);

  update_clear_checkboxes();

  return $('form#filter').bind("ajax:complete", function() {
    return $.bindTooltips();
  });
});
